export interface PalletVisualPart {
  id: string
  kind: 'runner' | 'block' | 'cross-member' | 'deck'
  x: number
  y: number
  z: number
  length: number
  width: number
  height: number
  tone: number
}

/** Stylized timber structure only; proportions are not fabrication specifications. */
export function buildPalletVisualParts(length: number, width: number, height: number): PalletVisualPart[] {
  if (![length, width, height].every(value => Number.isFinite(value) && value > 0)) return []
  const parts: PalletVisualPart[] = []
  const bottom = height * 0.15, block = height * 0.5, cross = height * 0.15
  const deckZ = bottom + block + cross
  const runnerWidth = width * 0.14, blockLength = length * 0.12
  const xs = [-length / 2, -blockLength / 2, length / 2 - blockLength]
  const ys = [-width / 2, -runnerWidth / 2, width / 2 - runnerWidth]
  ys.forEach((y, row) => {
    parts.push({ id: `runner-${row}`, kind: 'runner', x: -length / 2, y, z: 0, length, width: runnerWidth, height: bottom, tone: 0.92 + row * 0.025 })
    xs.forEach((x, column) => parts.push({ id: `block-${row}-${column}`, kind: 'block', x, y, z: bottom, length: blockLength, width: runnerWidth, height: block, tone: 0.9 + ((row + column) % 3) * 0.035 }))
  })
  xs.forEach((x, index) => parts.push({ id: `cross-${index}`, kind: 'cross-member', x, y: -width / 2, z: bottom + block, length: blockLength, width, height: cross, tone: 0.98 }))
  const boardWidth = width * 0.14, gap = (width - boardWidth * 5) / 4
  for (let index = 0; index < 5; index++) {
    parts.push({ id: `deck-${index}`, kind: 'deck', x: -length / 2, y: -width / 2 + index * (boardWidth + gap), z: deckZ,
      length, width: boardWidth, height: height - deckZ, tone: [1.05, 0.98, 1.02, 0.96, 1.04][index] })
  }
  return parts
}
